import WMUArchive from '../../wmu-archive/wmu-archive';

/**
 * 
 */
const wmuSlider = {
	resizeTimeoutID: null,
	widthMaxMobile: 750,
	widthMaxTablet: 990,
	widthMode: 'desktop',

	/**
	 * 
	 */
	archiveScrollElements: [],

	/**
	 * Swiper breakpoints setting keys
	 * 
	 * TODO: Ajouter les paramètres valides au fur et à mesure
	 */
	breakpointKeys: [ 'slidesPerView', 'slidesPerGroup', 'spaceBetween', 'slidesPerColumn' ],

	/**
	 * Swiper module setting keys
	 * 
	 * TODO: Ajouter les modules au fur et à mesure
	 * 
	 * @link https://swiperjs.com/swiper-api#modules
	 */
	moduleKeys: [ 'navigation', 'pagination', 'scrollbar', 'autoplay' ],

	/**
	 * Swiper defaults
	 * 
	 * @link https://swiperjs.com/swiper-api
	 */
	defaults: {
		// centeredSlides: true,
		spaceBetween: 1,
		/**
		 * En mettant speed (durée de transition en ms) à 0 on a un rendu sans transition
		 */
		// speed: 0,

		/**
		 * 
		 */
		// freeMode: true,

		/**
		 * Le mode loop et le freeMode créé du "snap" un peu curieux par moment. A voir si les différents paramètres liés à loop ne peuvent
		 * pas corriger ce problème.
		 */
		// loop: true,

		/**
		 * Le mode autoplay ne convient pas trop au freeMode. Ca reste un autoplay "par slide".
		 * Il faudra coder un comportement custom via les méthodes de swiper pour reproduire ce que Charles m'a montré.
		 */
		// autoplay: {
		// 	delay: 500,
		// }
	},

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	addArchiveScrollElement: ( element ) =>
	{
		if ( -1 === wmuSlider.archiveScrollElements.indexOf( element ) )
		{
			wmuSlider.archiveScrollElements.push( element );
		}
	},

	/**
	 * 
	 */
	removeArchiveScrollElement: ( element ) =>
	{
		const index = wmuSlider.archiveScrollElements.indexOf( element );

		if ( -1 !== index )
		{
			wmuSlider.archiveScrollElements.splice( index, 1 );
		}
	},

	/**
	 * Retrieve element slider data
	 */
	getData: ( element, forceReload = false ) =>
	{
		if ( element.wmuSlider && false === forceReload )
		{
			return element.wmuSlider;
		}

		return {
			settings: wmuSlider.getSettings( element, forceReload )
		};
	},

	/**
	 * Process module settings
	 * 
	 * Pour chaque clé de module déclaré on cherche dans les settings les paramètres préfixés par cette clé
	 * et on les regroupe en un objet de settings qu'on placera dans settings[ moduleKey ] si le module est actif.
	 * 
	 * Si le module est inactif on supprime l'entrée settings[ moduleKey ] ainsi que toutes les entrées settings[ modulePrefix + moduleKey ]
	 */
	processModuleSettings: ( settings ) =>
	{
		if ( ! settings )
		{
			return null;
		}

		wmuSlider.moduleKeys.forEach( ( moduleKey ) =>
		{
			let moduleSettings = {};
			const modulePrefix = moduleKey + '-';

			Object.keys( settings ).forEach( ( settingKey ) =>
			{
				if ( 0 === settingKey.indexOf( modulePrefix ) )
				{
					moduleSettings[ settingKey.slice( modulePrefix.length ) ] = settings[ settingKey ];
					delete settings[ settingKey ];
				}
			} );

			if ( true === settings[ moduleKey ] )
			{
				settings[ moduleKey ] = moduleSettings;
			}
			else
			{
				delete settings[ moduleKey ];
			}
		} );

		return settings;
	},

	/**
	 * Retrieve element slider settings
	 */
	getSettings: ( element, forceReload = false ) =>
	{
		if ( element.wmuSlider && false === forceReload )
		{
			return element.wmuSlider.settings;
		}

		let settings = {};

		/**
		 * Mobile slider settings
		 */
		let mobileSettings = element.getAttribute( 'data-swiper-mobile-settings' );
		mobileSettings = ( mobileSettings ) ? JSON.parse( mobileSettings ) : null;

		if ( mobileSettings )
		{
			// Remove 'mobile-' prefix from settings keys
			Object.keys( mobileSettings ).forEach( ( key ) =>
			{
				if ( 0 === key.indexOf( 'mobile-' ) )
				{
					mobileSettings[ key.slice( 7 ) ] = mobileSettings[ key ];
					delete mobileSettings[ key ];
				}
			} );
		}

		/**
		 * Tablet slider settings
		 */
		let tabletSettings = element.getAttribute( 'data-swiper-tablet-settings' );
		tabletSettings = ( tabletSettings ) ? JSON.parse( tabletSettings ) : null;

		if ( tabletSettings )
		{
			// Remove 'tablet-' prefix from settings keys
			Object.keys( tabletSettings ).forEach( ( key ) =>
			{
				if ( 0 === key.indexOf( 'tablet-' ) )
				{
					tabletSettings[ key.slice( 7 ) ] = tabletSettings[ key ];
					delete tabletSettings[ key ];
				}
			} );
		}

		/**
		 * Global slider settings
		 */
		let globalSettings = element.getAttribute( 'data-swiper-settings' );
		globalSettings = ( globalSettings ) ? JSON.parse( globalSettings ) : {};
		globalSettings = { ...wmuSlider.defaults, ...globalSettings };

		// TODO: Mettre en place le système de paramètres modules

		/**
		 * Save each settings
		 */
		settings.global = wmuSlider.processModuleSettings( globalSettings );
		settings.mobile = wmuSlider.processModuleSettings( mobileSettings );
		settings.tablet = wmuSlider.processModuleSettings( tabletSettings );

		/**
		 * Build settings with breakpoints if needed
		 * 
		 * TODO: Faire les réglages auto quand pas de settings particuliers mobile/tablet
		 */
		if ( ( settings.mobile && ! settings.mobile.sliderDisabled ) || ( settings.tablet && ! settings.tablet.sliderDisabled ) )
		{
			if ( settings.mobile )
			{
				settings.slider = { ...settings.global, ...settings.mobile, breakpoints: {} };

				// Sets tablet settings as breakpoint
				if ( settings.tablet )
				{
					settings.slider.breakpoints[ wmuSlider.widthMaxMobile ] = {};

					Object.keys( settings.tablet ).forEach( ( key ) =>
					{
						if ( -1 !== wmuSlider.breakpointKeys.indexOf( key ) )
						{
							settings.slider.breakpoints[ wmuSlider.widthMaxMobile ][ key ] = settings.tablet[ key ];
						}
					} );
				}
			}
			else if ( settings.tablet )
			{
				settings.slider = { ...settings.global, ...settings.tablet, breakpoints: {} };
			}

			// Sets global settings as breakpoint
			settings.slider.breakpoints[ wmuSlider.widthMaxTablet ] = {};

			Object.keys( settings.global ).forEach( ( key ) =>
			{
				if ( -1 !== wmuSlider.breakpointKeys.indexOf( key ) )
				{
					settings.slider.breakpoints[ wmuSlider.widthMaxTablet ][ key ] = settings.global[ key ];
				}
			} );
		}
		else
		{
			settings.slider = { ...settings.global };
		}

		/**
		 * Check for archive mode
		 */
		settings.archiveMode = element.classList.contains( 'structure-archive' );

		return settings;
	},

	/**
	 * 
	 */
	init: ( element ) =>
	{
		if ( element.wmuSlider && element.wmuSlider.sliderInit )
		{
			return;
		}

		let data = wmuSlider.getData( element );
		const windowWidth = window.innerWidth;
		const slideList = element.querySelector( '.slide-list' );
		element.wmuSlider = data;

		/**
		 * Archive mode initialization
		 */
		if ( data.settings.archiveMode && ! data.wmuArchive )
		{
			let archiveSettings = element.getAttribute( 'data-archive-settings' );
			archiveSettings = ( archiveSettings ) ? JSON.parse( archiveSettings ) : null;

			if ( null === archiveSettings )
			{
				return;
			}
			
			data.wmuArchive = new WMUArchive( {
				url: wmuSliderVars.ajaxUrl,
				nonce: wmuSliderVars.nonce,
				action: wmuSliderVars.action,
				...archiveSettings,
				onNextPage: ( pageItems, wmuArchive ) => {
					let slides = [];

					if ( true === data.sliderInit )
					{
						pageItems.forEach( ( item ) => {
							// slides.push( '<div class="block-slide swiper-slide">' + item + '</div>' )
							let slide = document.createElement( 'div' );
							slide.classList.add( 'block-slide' );
							slide.innerHTML = item;
							wmuSlider.setupSlide( slide );
							slides.push( slide );
						} );
						
						if ( slides.length > 0 )
						{
							data.swiper.appendSlide( slides );
							data.swiper.update();
						}
					}
					else
					{
						pageItems.forEach( ( item ) => {
							let slide = document.createElement( 'div' );
							slide.classList.add( 'block-slide' );
							slide.innerHTML = item;
							slideList.appendChild( slide );
						} );
					}
				}
			} );

			data.wmuArchive.nextPage();
		}

		if
		(
			( windowWidth >= wmuSlider.widthMaxTablet )
			|| ( windowWidth > wmuSlider.widthMaxMobile && ( ! data.settings.tablet || ! data.settings.tablet.sliderDisabled ) )
			|| ( ! data.settings.mobile || ! data.settings.mobile.sliderDisabled )
		)
		{
			/**
			 * Try to retrieve swiper container element
			 */
			wmuSlider.addSwiperClassnames( element );
			element.classList.add( 'slider-enabled' );
			const swiperContainer = element.querySelector( '.swiper-container' );

			if ( ! swiperContainer )
			{
				return;
			}

			/**
			 * Init swiper
			 */
			data.swiper = new Swiper( swiperContainer, data.settings.slider );

			/**
			 * Archive mode : Swiper event handlers
			 */
			if ( data.settings.archiveMode )
			{
				wmuSlider.removeArchiveScrollElement( element );

				/**
				 * 
				 */
				data.swiper.on( 'progress', function ( swiper, progress )
				{
					if ( progress >= 0.5 )
					{
						data.wmuArchive.nextPage();
					}
				} );
			}

			data.sliderInit = true;
		}
		else
		{
			if ( data.settings.archiveMode )
			{
				wmuSlider.addArchiveScrollElement( element );
			}

			wmuSlider.destroy( element );
		}
	},

	/**
	 * 
	 */
	destroy: ( element ) =>
	{
		if ( ! element.wmuSlider )
		{
			return;
		}

		if ( element.wmuSlider.swiper )
		{
			element.wmuSlider.swiper.destroy();
		}

		wmuSlider.removeSwiperClassnames( element );
		element.classList.remove( 'slider-enabled' );
		element.wmuSlider.sliderInit = false;

		/**
		 * Archive mode
		 */
		if ( element.wmuSlider.settings.archiveMode )
		{
			wmuSlider.addArchiveScrollElement( element );
		}
	},

	/**
	 * 
	 */
	addSwiperClassnames: ( element ) =>
	{
		element.querySelector( '.slider-container' ).classList.add( 'swiper-container' );
		element.querySelector( '.slide-list' ).classList.add( 'swiper-wrapper' );
		[].forEach.call( document.querySelectorAll( '.block-slide' ), function ( element )
		{
			wmuSlider.setupSlide( element );
		} );
	},

	/**
	 * 
	 */
	removeSwiperClassnames: ( element ) =>
	{
		element.querySelector( '.slider-container' ).classList.remove( 'swiper-container' );
		element.querySelector( '.slide-list' ).classList.remove( 'swiper-wrapper' );
		[].forEach.call( document.querySelectorAll( '.block-slide' ), function ( element )
		{
			element.classList.remove( 'swiper-slide', 'swiper-slide-active', 'swiper-slide-next', 'swiper-slider-prev' );

			[].forEach.call( element.querySelectorAll( 'img' ), ( element ) =>
			{
				element.setAttribute( 'loading', 'lazy' );
			} );
		} );
	},

	/**
	 * 
	 */
	setupSlide: ( element ) =>
	{
		element.classList.add( 'swiper-slide' );
		
		[].forEach.call( element.querySelectorAll( 'img[loading="lazy"]' ), ( img ) =>
		{
			img.removeAttribute( 'loading' );
		} );
	},

	/**
	 * 
	 */
	calculateWidthMode: () =>
	{
		let widthMode = 'desktop';
		const windowWidth = window.innerWidth;

		if ( windowWidth < wmuSlider.widthMaxMobile )
		{
			widthMode = 'mobile';
		}
		else if ( windowWidth < wmuSlider.widthMaxTablet )
		{
			widthMode = 'tablet';
		}

		return widthMode;
	},

	/**
	 * 
	 */
	onWindowResize: ( event ) =>
	{
		let widthMode = wmuSlider.calculateWidthMode();

		if ( widthMode === wmuSlider.widthMode )
		{
			return;
		}

		wmuSlider.widthMode = widthMode;

		/**
		 * Browse slider blocks and check for swiper init or destruction for the current window width
		 */
		[].forEach.call( document.querySelectorAll( '.wmu-block.block-slider' ), function ( element )
		{
			let settings = wmuSlider.getSettings( element );

			if ( settings[ widthMode ] && settings[ widthMode ].sliderDisabled && element.wmuSlider.sliderInit )
			{
				wmuSlider.destroy( element );
			}
			else if ( ! element.wmuSlider.sliderInit )
			{
				wmuSlider.init( element );
			}
		} );
	},

	/**
	 * 
	 */
	onWindowScroll: ( event ) =>
	{
		if ( 0 === wmuSlider.archiveScrollElements.length )
		{
			return;
		}

		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		
		wmuSlider.archiveScrollElements.forEach( ( element ) =>
		{
			if ( scrollTop > element.offsetTop && ( ( scrollTop - element.offsetTop ) / element.offsetHeight ) > 0.6 )
			{
				const data = wmuSlider.getData( element );
				data.wmuArchive.nextPage();
			}
		} );
	}
};

/**
 * Window resize behavior
 */
window.addEventListener( 'resize', function( event )
{
	// if ( wmuSlider.resizeTimeoutID )
	// {
	// 	window.clearTimeout( wmuSlider.resizeTimeoutID );
	// }

	// wmuSlider.resizeTimeoutID = window.setTimeout( function()
	// {
	// 	wmuSlider.onWindowResize( event );
	// 	wmuSlider.resizeTimeoutID = null;
	// }, 100 );
	wmuSlider.onWindowResize( event );
} );

/**
 * Window scroll behavior
 */
window.addEventListener( 'scroll', function ( event )
{
	wmuSlider.onWindowScroll( event );
} );

/**
 * Document is loaded
 */
document.addEventListener( 'DOMContentLoaded', function()
{
	wmuSlider.widthMode = wmuSlider.calculateWidthMode();

	/**
	 * Browse slider blocks and init swiper on each
	 * 
	 * @link https://swiperjs.com/swiper-api
	 */
	[].forEach.call( document.querySelectorAll( '.wmu-block.block-slider' ), function ( element )
	{
		wmuSlider.init( element );
	} );
} );